export enum ConnectionFeeType {
  None = 0,
  NoConnectionFee = 1,
  IsConnectionFee = 2,
  SIMWithRouter = 3,
  ONTConnectionFee = 4,
}